export const LOCALE_KEY = 'shiba.locale';

export const LOCALES = [
  { value: 'pt-BR', label: 'Português (Brasil)', shortLabel: 'Português' },
  { value: 'es', label: 'Español (Latinoamérica)', shortLabel: 'Espanhol' },
  { value: 'en', label: 'English', shortLabel: 'Inglês' },
] as const;

export type Locale = (typeof LOCALES)[number]['value'];

export function getLocale(): Locale {
  const saved = typeof localStorage === 'undefined' ? null : localStorage.getItem(LOCALE_KEY);
  return LOCALES.some((locale) => locale.value === saved) ? saved as Locale : 'pt-BR';
}

export function applyLocale(locale: Locale): void {
  localStorage.setItem(LOCALE_KEY, locale);
  document.documentElement.lang = locale;
}
